import styled from 'styled-components';
import { devices, theme } from '@/styles/theme/index.jsx';

export const StyledIndustryContainer = styled.section`
    padding: 120px 0 0;
    background: ${theme.colors.hover};
    margin-top: -1px;

    .services-list {
        .solution-last {
            svg {
                width: 100%;
                object-fit: cover;
                height: 82px;
                ${devices.xxl} {
                    height: 115px;
                }
                ${devices.md} {
                    height: 50px;
                }
            }
        }

        .service-item-mobile {
            margin-bottom: 40px;
            position: relative;
            &:after {
                height: 40px;
                width: 1px;
                content: '';
                background: ${theme.colors.white};
                position: absolute;
                bottom: -40px;
                left: 50%;
            }

            &:last-child {
                margin-bottom: 0;

                &:after {
                    display: none;
                }
            }
        }
    }

    .accordion {
        .accordion-item {
            background-color: ${theme.colors.transparent};
            border: none;
            border-radius: 0;
            color: ${theme.colors.white};
            padding-bottom: 20px;
            border-bottom: 1px solid ${theme.colors.white};

            &:nth-of-type(1) {
                .accordion-header {
                    .accordion-button {
                        padding-top: 0;
                    }
                }
            }

            .accordion-header {
                .accordion-button {
                    ${theme.fontGroup24}
                    color: ${theme.colors.white};
                    background-color: ${theme.colors.transparent};
                    border: none;
                    border-radius: 0;
                    padding-left: 0;
                    padding-bottom: 0;
                    padding-top: 30px;

                    &[aria-expanded='true'] {
                        svg {
                            &:nth-of-type(1) {
                                display: none;
                            }
                        }

                    }

                    svg {
                        right: 0;
                        position: absolute;
                    }

                    &:after {
                        display: none;
                    }
                }
            }

            .accordion-body {
                padding: 30px 0 0;

                .Industry-single__inner {
                    padding-top: ${theme.indusTryRatioMobile};
                }

                .Industry-single__inner__content {
                    background-color: ${theme.colors.transparent};
                    padding: 15px 0 0;
                }
            }
        }
    }


    ${devices.sm}{
        padding: 95px 0 0;
    }
`;
